// Tables
export const FIRESTORE_ORDERS_TABLE = "orders";
export const FIRESTORE_PRODUCTS_TABLE = "products";
export const FIRESTORE_PROMOTIONS_TABLE = "promotions";
export const FIRESTORE_USERS_TABLE = "users";
export const FIRESTORE_INVITED_USERS_TABLE = "invitedUsers";
export const FIRESTORE_DISCOUNT_CODES_TABLE = "discountCodes";
export const FIRESTORE_GROUPS_TABLE = "groups";
export const FIRESTORE_COLLECTIONS_TABLE = "collections";
export const FIRESTORE_FEATURED_PRODUCTS_TABLE = "featuredProducts";
export const FIRESTORE_CATEGORIES_TABLE = "categories";
export const FIRESTORE_CARTS_TABLE = "carts";
export const FIRESTORE_PURCHASE_ORDERS_TABLE = "purchaseOrders";
export const FIRESTORE_DEALERS_TABLE = "dealers";
export const FIRESTORE_PRODUCT_EVENTS_TABLE = "productEvents";
export const FIRESTORE_AUDIENCES_TABLE = "audiences";
export const FIRESTORE_EMAIL_QUEUE_TABLE = "emailQueue";
export const FIRESTORE_SUPPLIERS_TABLE = "suppliers";
export const FIRESTORE_SHIPMENTS_TABLE = "shipments";
export const FIRESTORE_PRODUCT_DRAFTS_TABLE = "productDrafts";
export const FIRESTORE_PURCHASE_ORDER_SHIPMENTS_TABLE = "purchaseOrderShipments";
export const FIRESTORE_PURCHASE_ORDER_INVOICES_TABLE = "purchaseOrderInvoices";
export const FIRESTORE_PURCHASE_ORDER_PAYMENTS_TABLE = "purchaseOrderPayments";
export const FIRESTORE_PURCHASE_ORDER_NOTIFICATIONS_TABLE = "purchaseOrderNotifications";
export const FIRESTORE_EXACT_HISTORY_TABLE = "exactHistory";
export const FIRESTORE_PRODUCT_COLORS_TABLE = "productColors";
export const FIRESTORE_PRODUCT_MATERIALS_TABLE = "productMaterials";
export const FIRESTORE_PRODUCT_COLOR_SHADES_TABLE = "productColorShades";
export const FIRESTORE_PRODUCT_MATERIAL_GROUPS_TABLE = "productMaterialGroups";
export const FIRESTORE_CONFIG = "config";

// Variables
export const FIRESTORE_PRODUCT_VARIATIONS_PRICE = "price";
export const FIRESTORE_DEFAULT_ORDERS_MAX_DAYS = 30;
